import {defineNuxtPlugin} from '#app'
import {route} from 'ziggy-js';

export default defineNuxtPlugin(nuxtApp => {
    const config = useRuntimeConfig()
    let manifest = null

    // Resolved on first call rather than here: the routes arrive with /api/public-config, which
    // 009.publicConfig.js fetches after this plugin has run. Nothing calls apiRoute before
    // components render, so the manifest is always present by first use.
    const resolve = () => {
        if (manifest) return manifest

        const ziggy = config.public.ziggy
        if (!ziggy) {
            throw new Error('Ziggy routes unavailable: /api/public-config did not load.')
        }

        // base url comes from the axios plugin, not from the manifest
        manifest = {...ziggy, url: ''}

        return manifest
    }

    const apiRoute = (name, params, absolute) => route(name, params, absolute, resolve())

    nuxtApp.vueApp.provide('apiRoute', apiRoute)

    return {
        provide: {
            apiRoute
        }
    }
})
